import client from './modules/client'
import project from './modules/project'
import documents from './modules/documents'
import existenceNewReports from './modules/existenceNewReports'
import projects from './modules/projects'
import forms from './modules/forms/index'
import positionsFilter from './modules/positionsFilter'

export default {
  namespaced: true,
  modules: {
    client,
    project,
    documents,
    existenceNewReports,
    projects,
    forms,
    positionsFilter
  }
}
